import { salesTileKeyType } from 'components/pages/GrowthAnalysis';
import { colorConstants } from 'config/colorConstants';
import { getAbsoluteChange, getPercentageChangeV2 } from 'utils/helperMethods';

export const othersString = 'Others';

const isOthersCategory = (name: string) => String(name).trim() === othersString;

export const attributeSalesKeyMapping: any = {
    sales: 'salesData',
    total: 'totalSalesData',
    salesData: 'salesData',
    sales_data: 'sales_data',
    baseData: 'baseData',
    incrementalData: 'incrementalData',
    promoData: 'promoData',
    nonPromoData: 'noPromoData',
};

export const tabMapping = {
    incremental: {
        tabs: ['Base', 'Incremental'],
        data: [attributeSalesKeyMapping.baseData, attributeSalesKeyMapping.incrementalData],
    },
    promo: {
        tabs: ['Non-promo', 'Promo'],
        data: [attributeSalesKeyMapping.nonPromoData, attributeSalesKeyMapping.promoData],
    },
};

export const minPercentageValue = -100;
export const maxPercentageValue = 200;

export function attributeSalesDataParser(
    data: any,
    from: salesTileKeyType = 'sales',
    graphDataKey: 'graphData' | 'graph_data' = 'graphData',
    salesData: 'salesData' | 'sales_data' = 'salesData',
    attributeTypeKey: 'attributeType' | 'attribute_type' = 'attributeType',
    showTotal: boolean = true,
) {
    const abs_volume: any = { data: [], minVal: 0, maxVal: 0 },
        percentage_volume: any = { data: [], minVal: 0, maxVal: 0 };
    const result = [abs_volume, percentage_volume];
    try {
        //for sales and depletion tabs
        if (from === 'sales' || from === 'depletion') {
            data.forEach((item: any, idx: number) => {
                const salesVolumeAbs = getAbsoluteChange(
                    item[graphDataKey][1][attributeSalesKeyMapping[salesData]],
                    item[graphDataKey][0][attributeSalesKeyMapping[salesData]],
                );

                const salesVolumePercentage = getPercentageChangeV2(
                    item[graphDataKey][1][attributeSalesKeyMapping[salesData]],
                    item[graphDataKey][0][attributeSalesKeyMapping[salesData]],
                );

                const absVolumeTempObj = {
                    sales: salesVolumeAbs,
                    labelSales: salesVolumeAbs,
                    category: item[attributeTypeKey],
                    color: Number(salesVolumeAbs) < 0 ? colorConstants.red : colorConstants.limeGreen,
                    disableHover:
                        isOthersCategory(item[attributeTypeKey]) ||
                        (showTotal && idx === 0) ||
                        (from === 'depletion' && !salesVolumeAbs),
                };

                //making sure it doesnt cross the range of minPercentageValue and maxPercentageValue
                const percentageSales =
                    salesVolumePercentage >= 0
                        ? Math.min(salesVolumePercentage, maxPercentageValue)
                        : Math.max(salesVolumePercentage, minPercentageValue);
                const percentageChangeVolumeTempObj = {
                    sales: percentageSales,
                    labelSales: salesVolumePercentage,
                    category: item[attributeTypeKey],
                    color: Number(salesVolumePercentage) < 0 ? colorConstants.red : colorConstants.limeGreen,
                    disableHover:
                        isOthersCategory(item[attributeTypeKey]) ||
                        (showTotal && idx === 0) ||
                        (from === 'depletion' && !salesVolumePercentage),
                };
                abs_volume.data.push(absVolumeTempObj);
                abs_volume.minVal = Math.min(abs_volume.minVal, salesVolumeAbs);
                abs_volume.maxVal = Math.max(abs_volume.maxVal, salesVolumeAbs);

                // abs_value.data.push(absValueTempObj);
                // abs_value.minVal = Math.min(abs_value.minVal, salesValueAbs);
                // abs_value.maxVal = Math.max(abs_value.maxVal, salesValueAbs);

                percentage_volume.data.push(percentageChangeVolumeTempObj);
                percentage_volume.minVal = Math.min(percentage_volume.minVal, percentageSales);
                percentage_volume.maxVal = Math.max(percentage_volume.maxVal, percentageSales);

                // percentage_value.data.push(percentageChangeValueTempObj);
                // percentage_value.minVal = Math.min(percentage_value.minVal, salesValuePercentage);
                // percentage_value.maxVal = Math.max(percentage_value.maxVal, salesValuePercentage);
            });
            //for incremental and promo
        } else {
            const updatedData = [...data];
            //looping 2 times to show grouped charts
            for (let i = 0; i < 2; i++) {
                const dataKey = tabMapping[from]['data'][i];
                const typeKey = tabMapping[from]['tabs'][i];
                updatedData.forEach((item: any) => {
                    const salesVolumeAbs = getAbsoluteChange(
                        item[graphDataKey][1][dataKey],
                        item[graphDataKey][0][dataKey],
                    );

                    const salesVolumePercentage = getPercentageChangeV2(
                        item[graphDataKey][1][dataKey],
                        item[graphDataKey][0][dataKey],
                    );

                    const absVolumeTempObj = {
                        sales: salesVolumeAbs,
                        labelSales: salesVolumeAbs,
                        category: item[attributeTypeKey],
                        color: Number(salesVolumeAbs) < 0 ? colorConstants.red : colorConstants.limeGreen,
                        type: typeKey,
                        disableHover: isOthersCategory(item[attributeTypeKey]),
                    };
                    //making sure it doesnt cross the range of minPercentageValue and maxPercentageValue
                    const percentageSales =
                        salesVolumePercentage >= 0
                            ? Math.min(salesVolumePercentage, maxPercentageValue)
                            : Math.max(salesVolumePercentage, minPercentageValue);
                    const percentageChangeVolumeTempObj = {
                        sales: percentageSales,
                        labelSales: salesVolumePercentage,
                        category: item[attributeTypeKey],
                        color: Number(salesVolumePercentage) < 0 ? colorConstants.red : colorConstants.limeGreen,
                        type: typeKey,
                        disableHover: isOthersCategory(item[attributeTypeKey]),
                    };
                    abs_volume.data.push(absVolumeTempObj);
                    abs_volume.minVal = Math.min(abs_volume.minVal, salesVolumeAbs);
                    abs_volume.maxVal = Math.max(abs_volume.maxVal, salesVolumeAbs);

                    // abs_value.data.push(absValueTempObj);
                    // abs_value.minVal = Math.min(abs_value.minVal, salesValueAbs);
                    // abs_value.maxVal = Math.max(abs_value.maxVal, salesValueAbs);

                    percentage_volume.data.push(percentageChangeVolumeTempObj);
                    percentage_volume.minVal = Math.min(percentage_volume.minVal, percentageSales);
                    percentage_volume.maxVal = Math.max(percentage_volume.maxVal, percentageSales);

                    //  percentage_value.data.push(percentageChangeValueTempObj);
                    // percentage_value.minVal = Math.min(percentage_value.minVal, salesValuePercentage);
                    // percentage_value.maxVal = Math.max(percentage_value.maxVal, salesValuePercentage);
                });
            }
        }
        return result;
    } catch (error) {
        return result;
    }
}
